/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Placewebpublished2Inputs */

const en_placewebpublished2 = /** @type {(inputs: Placewebpublished2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} is now on Pulsify`)
};

const de_placewebpublished2 = /** @type {(inputs: Placewebpublished2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} ist jetzt auf Pulsify`)
};

/**
* | output |
* | --- |
* | "{name} is now on Pulsify" |
*
* @param {Placewebpublished2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placewebpublished2 = /** @type {((inputs: Placewebpublished2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placewebpublished2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placewebpublished2(inputs)
	return de_placewebpublished2(inputs)
});
export { placewebpublished2 as "placeWebPublished" }